import React, {useEffect, useState} from "react";
import {collection, getDocs, query, where, addDoc, Timestamp} from "firebase/firestore";
import {auth, db} from "../firebase";
import goldCrown from "../img/icons/gold crown.png";
import bronzeCrown from "../img/icons/bronze crown.png";
import silverCrown from "../img/icons/bronze crown (1).png";
import {useNavigate} from "react-router";
import {SignOut} from "../App";
import Check from "../img/icons/Eo_circle_green_checkmark.svg.webp";

export default function Voting({queryParam}) {
    console.log(queryParam);
    const navigate = useNavigate();
    const [voted, setVoted] = useState(false);
    const [voteableRides, setVotableRides] = useState([]);
    const [selectedRides, setSelectedRides] = useState({gold: null, silver: null, bronze: null});

    useEffect(() => {
        const checkUserVote = async () => {
            const votesRef = collection(db, "session");
            const q = query(votesRef, where("session_code", "==", queryParam));
            const querySnapshot = await getDocs(q);
            console.log(querySnapshot);
            if (querySnapshot.empty) {
                auth.signOut();
                navigate("/");
            }
            querySnapshot.forEach((doc) => {
                const park = doc.data();
                fetchAvailableRides(park.park);
            });
        };

        checkUserVote();
    }, [queryParam]);

    async function fetchAvailableRides(park) {
        try {
            const response = await fetch(`https://tp.arendz.nl/parks/${park}/rides`);
            if (response.ok) {
                const data = await response.json();
                setVotableRides(data);
                console.log(data);
            } else {
                console.error("Error fetching data:", response.statusText);
            }
        } catch (error) {
            console.error("Fetch failed:", error);
        }
    }

    function handleSelection(type, event) {
        const selectedRide = voteableRides.find(ride => ride.title === event.target.value);
        setSelectedRides(prev => ({...prev, [type]: {name: selectedRide.title, image: selectedRide.image_url}}));
        console.log(type);
    }

    async function submitVote() {
        if (!selectedRides.gold || !selectedRides.silver || !selectedRides.bronze) {
            alert("Please select a ride for all categories.");
            return;
        }

        const voteData = {
            id: 232324,
            session: queryParam,
            timestamp: Timestamp.fromDate(new Date()),
            person: auth.currentUser.displayName,
            photo: auth.currentUser.photoURL,
            votes: [
                {name: selectedRides.gold.name, image: selectedRides.gold.image},
                {name: selectedRides.silver.name, image: selectedRides.silver.image},
                {name: selectedRides.bronze.name, image: selectedRides.bronze.image}
            ]
        };

        try {
            await addDoc(collection(db, "votes"), voteData);
            console.log("Vote successfully submitted.");
            setVoted(true)
        } catch (error) {
            console.error("Error submitting vote:", error);
        }
    }

    return (
        <div
            style={{width: "100vw", display: "flex", flexDirection: "column", alignItems: "center", marginTop: "40px"}}>
            {!voted ? (
                <>
                    <h1 style={{marginTop: 0}}>Keuze</h1>
                    <p style={{fontStyle: "italic"}} className="h1Footer">
                        Selecteer de 3 attracties waar u het liefst in wilt gaan. Op basis van uw keuze en die van uw
                        groep stelt Trackless een top 3 samen waarin iedere mening wordt meegenomen.
                    </p>
                    {['gold', 'silver', 'bronze'].map((type) => (
                        <div className="box" key={type} style={{position: "relative"}}>
                            <div className={`paddingLeft ${selectedRides[type] ? 'Active' : ''}`}
                                 style={{
                                     width: "35px",
                                     height: "100%",
                                     backgroundColor:
                                         type === 'gold' ? "rgb(255 200 71)" :
                                             type === "silver" ? "rgb(186 186 186)" : "rgb(112 63 56)",
                                     position: "absolute"
                                 }}
                            ></div>
                            <img
                                id={type}
                                className={`crowns ${selectedRides[type] ? 'Active' : ''}`}
                                style={{
                                    boxShadow:
                                        type === 'gold' ? "0px 0px 0px 4px rgb(255 200 71)" :
                                            type === 'silver' ? "0px 0px 0px 4px rgb(186 186 186)" :
                                                "0px 0px 0px 4px rgb(112 63 56)",
                                    objectFit: selectedRides[type] ? 'cover' : 'contain'
                                }}
                                src={
                                    selectedRides[type]?.image ||
                                    (type === 'gold' ? goldCrown : type === 'silver' ? silverCrown : bronzeCrown)
                                }
                                alt={`${type} crown`}
                            />
                            <div className={`selectArea ${selectedRides[type] ? 'Active' : ''}`}>
                                <select onChange={(e) => handleSelection(type, e)}>
                                    <option value="">Kies een attractie</option>
                                    {voteableRides.map((ride) => (
                                        <option key={ride.title} value={ride.title}>{ride.title}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    ))}
                    <div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                        <button onClick={submitVote} style={{position: "relative", marginTop: "20px"}}>Stemmen</button>
                        <div style={{
                            margin: "20px 0",
                            height: "0.1px",
                            width: "250px",
                            backgroundColor: "#c0c0c0"
                        }}></div>
                        <SignOut/>
                    </div>
                </>
            ) : (
                <div className="votedContainer">
                    <h1 style={{marginTop: 0}}>Gelukt!</h1>
                    <p style={{fontStyle: "italic"}} className="h1Footer">Uw stem is ingediend! Kijk mee in de Trackless app van de host voor de uitslag.</p>
                    <div style={{position: "relative"}}>
                        <img src={Check} style={{width: "200px", marginTop: "50px"}} alt="Checkmark"/>
                        <img style={{border: "4px solid rgb(255 200 71)", top: "30px", left: "-40px"}}  className={"floatingImg"}
                             src={selectedRides.gold.image}></img>
                        <img style={{border: "4px solid rgb(186 186 186)", bottom: "80px", right: "-60px"}} className={"floatingImg"}
                             src={selectedRides.silver.image}></img>
                        <img style={{border: "4px solid rgb(112 63 56)", bottom: "-25px", left: "-20px"}}  className={"floatingImg"}
                             src={selectedRides.bronze.image}></img>
                    </div>
                </div>
            )}
        </div>
    );
}
